// element-ui.js
import Vue from 'vue'
import { Button, Input, Select, Dropdown, DropdownItem, DropdownMenu, Popover, Option, OptionGroup, Tabs, TabPane, Upload, Form, FormItem } from 'element-ui'
import locale from 'element-ui/lib/locale/lang/en'
import '~/styles/element-variables.scss'
import '~/styles/element.scss'

const components = [Button, Input, Select, Dropdown, DropdownItem, DropdownMenu, Popover, Option, OptionGroup, Tabs, TabPane, Upload, Form, FormItem]

const Element = {
  install(Vue) {
    components.forEach((component) => {
      Vue.component(component.name, component)
    })
  }
}

Vue.use(Element, { locale })
